import {
  ELEMENT_TYPE_ARTICLE,
  ELEMENT_TYPE_NAVIGATION_SECTION,
  ELEMENT_TYPE_PICTURE,
  ELEMENT_TYPE_SECTION_GROUP
} from '../../consts/element-types';
import NavigationElement from './elements/NavigationElement';
import PictureElement from './elements/PictureElement';
import SectionElement from './elements/SectionElement';
import TextElement from './elements/TextElement';

export default class ElementFactory {
  static instantiateElement(element) {
    const type = element.type;

    if (type === ELEMENT_TYPE_PICTURE) {
      return new PictureElement(element);
    }

    if (type === ELEMENT_TYPE_ARTICLE) {
      return new TextElement(element);
    }

    if (type === ELEMENT_TYPE_SECTION_GROUP) {
      return new SectionElement(element);
    }

    if (type === ELEMENT_TYPE_NAVIGATION_SECTION) {
      return new NavigationElement(element);
    }

    throw new Error(`Unknown element type: ${type}`);
  }
}
